module.exports = __webpack_public_path__ + "img/111044.63c6d2bd.png";